// @flow
import React, { Component } from 'react';
import {autorun, toJS} from 'mobx';
import { observer } from 'mobx-react';
import debounce from 'lodash/debounce';
import merge from 'lodash/merge';
import './PreviewPanel.scss';

declare var cloudinary: any;

type Props = {
  widgetPropsFromFormState: Object,
  initFormState: Function,
  setDefaults: Function,
  embedded: boolean
}

type State = {
  galleryWidth: string,
}

@observer
class PreviewPanel extends Component<Props, State> {
  init: boolean = false
  updateConfigDisposer: Function
  myWidget: null

  state = {
    galleryWidth: 'none'
  }

  componentDidMount() {
    this.handleGalleryWidth();
    this.initGallery();
  }

  componentWillUnmount() {
    if (this.updateConfigDisposer) {
      this.updateConfigDisposer();
    }
  }

  initGallery = () => {
    this.props.setDefaults();
    const config = merge({}, toJS(this.props.widgetPropsFromFormState));

    this.myWidget = cloudinary.galleryWidget(merge({}, config, {
      container: '#my-gallery',
      displayProps: { topOffset: this.props.embedded ? 10 : 65 }
    }));

    this.myWidget.render();

    if (this.myWidget && this.myWidget.config != null && this.myWidget.options != null) {
      this.props.initFormState(merge({}, this.myWidget.config, this.myWidget.options));
    }

    const updateWidget = (props) => {
      this.handleGalleryWidth();
      if (this.myWidget) {
        const config = merge({}, toJS(props));
        this.myWidget.update(config);
      }
    };

    const debounceUpdate = debounce(updateWidget, 500);

    this.updateConfigDisposer = autorun(() => {
      const config = this.props.widgetPropsFromFormState;
      if (this.init) {
        debounceUpdate(config);
      }
      setTimeout(() => { this.init = true; });
    });
  }

  handleGalleryWidth = () => {
    if (!document.body) return;
    // Gallery is width-fluid but ignores available height.
    // We set the gallery max width so that it fills the preview-panel HEIGHT
    // taking into account the aspect-ratio defined for the gallery and the various paddings.
    const config = this.props.widgetPropsFromFormState;
    let previewWidth = document.body.clientWidth - 450; // - form-panel
    let hPad = 0.02 * document.body.clientWidth + 0.02 * previewWidth;
    let vPad = 0.02 * previewWidth;
    let headerHeight = this.props.embedded ? 0 : 55;
    let previewHeight = document.body.clientHeight - headerHeight;

    const ratioStr = config.aspectRatio || 'square';
    const ratio = ratioStr.indexOf(':') > -1
      ? parseInt(ratioStr.split(':')[0], 10) / parseInt(ratioStr.split(':')[1], 10)
      : 1;

    if (!config.carouselStyle || config.carouselStyle == 'thumbnails') {
      if (!config.carouselLocation || config.carouselLocation == 'left' || config.carouselLocation == 'right') {
        vPad = vPad + (config.thumbnailProps && config.thumbnailProps.width || 64) + (config.carouselOffset || 5);
      }
      else if (config.carouselLocation == 'top' || config.carouselLocation == 'bottom') {
        hPad = hPad + (config.thumbnailProps && config.thumbnailProps.height || 64) - (config.carouselOffset || 5);
      }
    }

    let maxWidth = ((previewHeight - hPad) * ratio) + vPad;
    this.setState({ galleryWidth: maxWidth + 'px' });
  }

  render() {
    return (
      <div
        className="preview-wrapper"
        style={{ maxWidth: this.state.galleryWidth }}
      >
        <div id="my-gallery"/>
      </div>
    );
  }
}

export default PreviewPanel;
